import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  showIcon?: boolean;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  children,
  fullWidth = false,
  showIcon = true,
  variant = 'primary',
  className = '',
  href,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-warm-lg hover:shadow-warm-xl transform active:scale-95';
  const variants = {
    primary: 'bg-gradient-to-r from-coral-500 to-coral-600 text-white hover:from-coral-600 hover:to-coral-700 border border-transparent',
    secondary: 'bg-white text-coral-600 border-2 border-coral-500 hover:bg-coral-50'
  };
  const sizes = 'py-4 px-8 text-lg md:text-xl tracking-wide';
  const content = <>
      {children}
      {showIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-163" />}
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${variants[variant]} ${sizes} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-164">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-165">
      {content}
    </motion.button>;
}